import { createSlice } from "@reduxjs/toolkit";

const initialState = false;
const bgmSlice = createSlice({
    name: "bgm",
    initialState,
    reducers: {
        setTrue: (state) => {
            return true;
        },
        setFalse: (state) => {
            return false;
        },
    },
});
export const { setTrue, setFalse } = bgmSlice.actions;
export default bgmSlice.reducer;
